import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'formdata-polyfill';
import ReactDOM from 'react-dom';
import preval from 'preval.macro';
import routes from './routes';
import XNAT from './xnat/XNAT';
import errorLogging from './errorLogging';

import './styles/index.scss';

const buildTime = preval`module.exports = Date.now();`;

window.config = {
   build: new Date(buildTime).toLocaleString(),
   url: process.env.REACT_APP_URL,
   login: {
      username: process.env.REACT_APP_USERNAME,
      password: process.env.REACT_APP_PASSWORD,
      autologin: !!(process.env.REACT_APP_USERNAME && process.env.REACT_APP_PASSWORD),
   }
};

if (window.document.all) { // only supported in IE10 and older
   window.alert('Ihr Browser ist leider zu alt, um diese Anwendung zu benutzen. Bitte installieren Sie einen zeitgemäßen Browser.');
}
else {
   if (process.env.NODE_ENV === 'production') {
      errorLogging.init();
   }

   window.xnat = new XNAT(`${window.location.origin}/xnat/REST`);

   const node = document.getElementById('root');
   ReactDOM.render(routes(), node);
}
